import {
  DEFAULT_CONFIDENCE_THRESHOLD,
  EDGE_GROUP_LABELS,
  MAX_CONFIDENCE_THRESHOLD,
  MIN_CONFIDENCE_THRESHOLD,
} from "./graphWidgetFilters.js"
import { ALL_EDGE_GROUPS } from "./graphWidgetUrlState.js"

export default function GraphFilterPanel({
  edgeGroups,
  onEdgeGroupsChange,
  confidenceThreshold,
  onConfidenceThresholdChange,
  verifiedOnly,
  onVerifiedOnlyChange,
  disabled = false,
}) {
  const toggleEdgeGroup = (group) => {
    if (edgeGroups.includes(group)) {
      if (edgeGroups.length === 1) return
      onEdgeGroupsChange(edgeGroups.filter((entry) => entry !== group))
      return
    }

    onEdgeGroupsChange([...edgeGroups, group].sort())
  }

  return (
    <fieldset
      className="mt-4 rounded-md border border-border bg-surface-muted px-3 py-3 sm:px-4"
      disabled={disabled}
    >
      <legend className="px-1 text-xs font-semibold uppercase tracking-wide text-text-muted">
        Graph filters
      </legend>

      <div className="mt-2">
        <p className="text-xs font-medium text-text-secondary">Connection types</p>
        <ul className="mt-2 flex flex-wrap gap-x-4 gap-y-2">
          {ALL_EDGE_GROUPS.map((group) => (
            <li key={group}>
              <label className="inline-flex items-center gap-2 text-sm text-text-secondary">
                <input
                  type="checkbox"
                  checked={edgeGroups.includes(group)}
                  onChange={() => toggleEdgeGroup(group)}
                  className="rounded border-border text-blue-600 focus:ring-blue-600 dark:bg-slate-800"
                />
                <span>{EDGE_GROUP_LABELS[group]}</span>
              </label>
            </li>
          ))}
        </ul>
      </div>

      <div className="mt-4 grid gap-4 sm:grid-cols-2">
        <label className="flex min-w-[12rem] flex-col gap-1 text-xs font-medium text-text-secondary">
          <span>Minimum confidence</span>
          <input
            type="range"
            min={MIN_CONFIDENCE_THRESHOLD}
            max={MAX_CONFIDENCE_THRESHOLD}
            step={0.05}
            value={confidenceThreshold}
            onChange={(event) => onConfidenceThresholdChange(Number.parseFloat(event.target.value))}
            aria-label={`Minimum confidence threshold: ${confidenceThreshold.toFixed(2)}`}
            aria-valuemin={MIN_CONFIDENCE_THRESHOLD}
            aria-valuemax={MAX_CONFIDENCE_THRESHOLD}
            aria-valuenow={confidenceThreshold}
            className="w-full accent-blue-600 disabled:cursor-not-allowed disabled:opacity-50"
          />
          <span className="text-text-muted">
            {confidenceThreshold.toFixed(2)}
            {confidenceThreshold === DEFAULT_CONFIDENCE_THRESHOLD ? " (default)" : ""}
          </span>
        </label>

        <label className="flex items-start gap-2 self-end text-sm text-text-secondary">
          <input
            type="checkbox"
            checked={verifiedOnly}
            onChange={(event) => onVerifiedOnlyChange(event.target.checked)}
            className="mt-0.5 rounded border-border text-blue-600 focus:ring-blue-600 dark:bg-slate-800"
          />
          <span>
            <span className="font-medium">Show only verified</span>
            <span className="mt-0.5 block text-xs text-text-muted">
              Hides edges that have not been admin-verified.
            </span>
          </span>
        </label>
      </div>
    </fieldset>
  )
}
